import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedserviceService,CommonService } from 'src/app/services';
import { getLocaleTimeFormat } from '@angular/common';
declare var $: any;
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  id: any;
  logForm: FormGroup;
  token: any;
  user_id: any;
  errors: any;
  hidediv:boolean=false;
  show: boolean = false;
  submitted = false;type:any;btndisabled:boolean=false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public sharedService: SharedserviceService,
    public router: Router,public commonService:CommonService,
    private toastr: ToastrManager) {
  }

  ngOnInit() {
    if(this.commonService.getToken()){this.router.navigate(['/dashboard']);}
    this.logForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      device_token:["44634w8q7d7edwq6eqw46"],
      device_type:["web"]
    });
  }
  get f() { return this.logForm.controls; }
 
  logUser() {
    
//console.log(this.logForm.value);
    this.submitted = true;
    if (this.logForm.invalid) {
      return;
    }else{
      this.hidediv=true;
      this.showloader()
      var self=this;
      self.btndisabled= true;
      this.sharedService.post('v1/users/login',this.logForm.value).subscribe((res)=> {
        if(res.replyCode == 'success'){
          this.hideloader()
          var role=res.data.role_id;
            // localStorage.clear();
            // sessionStorage.clear()
            localStorage.setItem("userAgency_kamla", JSON.stringify(res.data));
            localStorage.setItem("imgpathAgency", JSON.stringify(res.imageurl));
            localStorage.setItem("tokenAgency_kamla", JSON.stringify(res.data.login_token));
            this.toastr.successToastr(res.replyMsg, 'Success');
            this.router.navigateByUrl('/dashboard');
        }else{
          self.btndisabled= false; 
          this.hideloader()
          this.hidediv=false;
          this.toastr.errorToastr(res.replyMsg, 'Error');
        }
      },err=>{
          this.hideloader()
          this.hidediv=false;
        // self.sharedService.loadingShow = false;
          self.btndisabled= false;
          self.toastr.errorToastr(err.error.replyMsg,"Error")

      });
    }
  }

  hideloader() { 
    document.getElementById('loader').style.display = 'none'; 
  }
  showloader() { 
    document.getElementById('loader').style.display = 'block'; 
  }

  checkPwd(){
    this.show = !this.show;
  }
}

